import apiConfig from './url'
import request from './request'
import axios from 'axios'
let setFormHeaders=()=>{
	axios.defaults.headers= {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
	axios.defaults.transformRequest=[function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      ret=ret.substr(0,ret.length-1)
      return ret
    }]
}

let apis={
	_auth:(params,data,sc,ec)=>{
		return request(params,'get',apiConfig.authUrl,data,sc,ec)
	},
	_login:(params,data,sc,ec)=>{
		return request(params,'post',apiConfig.loginUrl,data,sc,ec,setFormHeaders)
	},
	_point:(params,data,sc,ec)=>{
		return request(params,'get',apiConfig.pointListUrl,data,sc,ec)
  },
  _order: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.orderUrl, data, sc, ec)
  },
  _worksheet: (params, data, sc, ec) => {
    return request(params, 'post', apiConfig.worksheetUrl, data, sc, ec, setFormHeaders)
  },
  _report: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.reportUrl, data, sc, ec)
  },
  _device: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.deviceListUrl, data, sc, ec)
  },
  _enginner: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.enginnerUrl, data, sc, ec)
  },
  _customer: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.customerUrl, data, sc, ec)
  },
  _personal: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.personalUrl, data, sc, ec)
  },
  _asset: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.assetUrl, data, sc, ec)
  },
  _monitor: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.monitorUrl, data, sc, ec)
  },
  _topo: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.topoUrl, data, sc, ec)
  },
  _chatname: (params, data, sc, ec) => {
    return request(params, 'post', apiConfig.chatNameUrl, data, sc, ec, setFormHeaders)
  },
  _logout: (params, data, sc, ec) => {
    return request(params, 'get', apiConfig.logoutUrl, data, sc, ec)
  },
}

export function _api(method,params,data,sc,ec){
	return apis[method](params,data,sc,ec)
}



// WEBPACK FOOTER //
// ./src/service/interface.js